import React from "react";
import "../App.css";
import { Container } from "@mui/system";
import { Divider, Grid, Typography } from "@mui/material";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import AnimatedLetters from "./AnimatedLetters";
import { useEffect, useState } from "react";
export default function Descripcion() {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [letterClass, setLetterClass] = useState("text-animate");
  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 1000);
  }, []);
  return (
    <>
      <Container
        maxWidth="xl"
        sx={{
          display: { md: "block", xs: "none" },
          width: "80%",
          textAlign: "center",
          paddingBottom: "5%",
          paddingTop: 3,
        }}
        id="descripción"
      >
        <img
          src="/logo_pre.png"
          className="imageDesc"
          alt="We can dig it logo"
        />
        <Typography variant="h2">
          Las minas en{" "}
          <Typography sx={{ color: "#ffa300" }} variant="h1">
            We can Dig it
          </Typography>
        </Typography>

        <Grid container spacing={1}>
          <Grid item xs={5}>
            {" "}
            <Typography className="descripcion" variant="inherit">
              El videojuego “We can dig it”, es videojuego de plataformas en
              cual consiste que un minero va luchando con bestias para poder
              llegar al centro de la tierra, cual tiene como herramienta
              principal y única un pico para matar a las bestias y superar los
              obstáculos que saldrán durante su travesía.
            </Typography>
            <Typography className="descripcion" variant="inherit">
              “We can dig it” es la travesía de un minero en su viaje al centro
              de la tierra sin embargo en su camino tendrá que enfrentarse con
              diversas bestias, para sobrevivir esto con su única arma un pico,
              en su viaje en descubrir los misterios que contienen las
              profundidades de la tierra. Usa las habilidades clásicas de un
              videojuego de plataformas para continuar con los siguientes
              escenarios.
            </Typography>
          </Grid>
          <Grid item xs={7}>
            <iframe
              className="iframe"
              width="560"
              height="315"
              src="https://www.youtube.com/embed/OWegqBxjZc0"
              title="We Can Dig It Trailer Oficial"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </Grid>
        </Grid>
        <Divider />
      </Container>
      <Container
        maxWidth="xl"
        sx={{
          display: { md: "none", xs: "block" },
          width: "80%",
          textAlign: "center",
        }}
        id="descripcion"
      >
        <img
          src="/logo_pre.png"
          className="imageDesc"
          alt="We can dig it logo"
        />
        <Typography variant="h4">Las minas en We can Dig it</Typography>
        <Typography className="descripcion" variant="inherit">
          El videojuego “We can dig it”, es videojuego de plataformas en cual
          consiste que un minero va luchando con bestias para poder llegar al
          centro de la tierra, cual tiene como herramienta principal y única un
          pico para matar a las bestias y superar los obstáculos que saldrán
          durante su travesía.
        </Typography>
        <Typography className="descripcion" variant="inherit">
          “We can dig it” es la travesía de un minero en su viaje al centro de
          la tierra sin embargo en su camino tendrá que enfrentarse con diversas
          bestias, para sobrevivir esto con su única arma un pico, en su viaje
          en descubrir los misterios que contienen las profundidades de la
          tierra. Usa las habilidades clásicas de un videojuego de plataformas
          para continuar con los siguientes escenarios.
        </Typography>

        <iframe
          className="iframe"
          width="560"
          height="315"
          src="https://www.youtube.com/embed/OWegqBxjZc0"
          title="We Can Dig It Trailer Oficial"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
        <Divider />
      </Container>
    </>
  );
}
